import React from 'react';
import { Link } from 'react-router-dom';
import { useGame } from '../context/GameContext';
import { CASINO_GAMES } from '../config/casinoGames';
import './GameHome.css';

export function GameHome() {
  const { gameState, addBalance } = useGame();
  const isBroke = gameState.balance <= 0;

  return (
    <div className="game-home casino-lobby">
      <div className="game-home-container">
        <h1 className="game-title">🎰 Casino</h1>
        <p className="game-subtitle">Pelaa vastuullisesti – vain viihde. 15 peliä.</p>

        <div className="casino-balance-box">
          <span className="casino-balance-label">Saldo</span>
          <span className="casino-balance-amount">€{gameState.balance}</span>
          {isBroke && (
            <button
              type="button"
              className="casino-refill-btn"
              onClick={() => addBalance(500)}
            >
              + €500 (demo)
            </button>
          )}
        </div>

        <div className="casino-games-grid">
          {CASINO_GAMES.map((game) =>
            game.comingSoon ? (
              <div key={game.id} className="game-menu-card casino-card coming-soon">
                <span className="game-menu-icon">{game.icon}</span>
                <h2>{game.name}</h2>
                <p>{game.description}</p>
                <span className="coming-soon-badge">Tulossa</span>
              </div>
            ) : (
              <Link key={game.id} to={game.path!} className="game-menu-card casino-card">
                <span className="game-menu-icon">{game.icon}</span>
                <h2>{game.name}</h2>
                <p>{game.description}</p>
              </Link>
            )
          )}
        </div>

        <div className="game-stats casino-stats">
          <p>Voitot: <strong>{gameState.totalWins}</strong> / {gameState.totalSpins} kierrosta</p>
        </div>
      </div>
    </div>
  );
}
